import React from 'react';
import styled from 'styled-components';
import {UserContext} from "@providers/user";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {getThumbnailPath} from "@models/property";
import ConvertPixelToRem from "@helpers/convert.rem";
import Icon from "@atoms/icon";
import {time_ago, isEmpty} from "@helpers/helpers";
import {
    checkPropertyIsAssignedAndOwner,
    getPropertyUrl,
    handleTitle,
    getPropertyVideoPath
} from "../helpers/property_helpers";
import MediaItems from "./media_items";
import {inArray} from "@helpers/arrays";
import BookmarkIcon from '@icons/bookmark.svg'
import PhoneIcon from "@icons/phone.svg";
import TransactionIcon from "@icons/transaction.svg";
import EyeIcon from '@icons/eye.svg';

export default function CardImage({
                                      property,
                                      isBadeSaba,
                                      className,
                                      setContactInfo,
                                      handleShowProperty,
                                      handleBookmark,
                                      bookmarkedProperties,
                                      categories,
                                      handleShowNoResult,
                                      imgCount,
                                      videoCount,
                                      selectedCityFilter,
                                      isGridList = false
                                  }) {
    const userContext = React.useContext(UserContext);
    const authUser = (userContext.check && !isEmpty(userContext.user)) ? userContext.user : null;
    const {boosted_at, request_contact} = property;
    const showRequestForm = (request_contact || isBadeSaba);

    const assignedAndIsOwner = checkPropertyIsAssignedAndOwner(property);
    const videoPath = getPropertyVideoPath(property);


    const handleClickOnContactButton = () => {
        if (!property.archived) {
            setContactInfo({
                show: true,
                property_id: property.id,
                city_id: property.city_id,
                district_id: property.district_id,
                realtor_id: null,
                agency_id: null,
                isAssignedProperty: assignedAndIsOwner,
                isOnList: true,
                exists_in_kanban: showRequestForm,
                isBadeSaba: isBadeSaba,
            })
        }
    };

    const handleClickOnBookmark = (property_id, follow) => {
        if (userContext.check) {
            const followBox = document.querySelector('.follow-box-' + property_id);

            if (followBox.classList.contains('followed')) {
                followBox.classList.remove('followed');

                if (!isEmpty(authUser) && !isEmpty(categories) && categories === 'follow') {
                    const propertyContainerCount = document.querySelectorAll('.property-container').length;
                    const propertyContainer = followBox.closest('.property-container');

                    propertyContainer.style.transition = 'opacity 500ms ease';
                    propertyContainer.style.opacity = '0';

                    setTimeout(function () {
                        propertyContainer.parentNode.removeChild(propertyContainer);

                        if (propertyContainerCount <= 1) {
                            handleShowNoResult();
                        }
                    }, 700);
                }
            } else {
                followBox.classList.add('followed');
            }
        }

        handleBookmark(property_id, follow, userContext)
    };


    return (
        <Card
            className={(className ?? '') + ((videoPath && !isEmpty(property) && !property.archived) ? ' has-video' : '')}>

            <PropertyImageCustomTag
                is_link={isEmpty(videoPath)}
                getPropertyUrl={getPropertyUrl}
                property={property}
                isBadeSaba={isBadeSaba}
                handleShowProperty={handleShowProperty}
                item_count={(imgCount + videoCount)}
            >
                <Image className={"position-relative cursor-pointer " + (property.archived ? 'is-archived' : '')}>

                    {
                        (videoPath && !isEmpty(property) && !property.archived) ?
                            <VideoIframeCard className="">
                                <span style={{display: 'block', paddingTop: '57%'}}/>
                                <iframe src={videoPath} allowFullScreen="true" webkitallowfullscreen="true"
                                        mozallowfullscreen="true"/>

                                <VideoIframeTime>
                                    <Time className={((imgCount > 0) ? 'text-white' : '')}>{time_ago(boosted_at, '6_month')}</Time>
                                </VideoIframeTime>
                            </VideoIframeCard>
                            :
                            <LazyLoadImage
                                src={getThumbnailPath(property, null, null, isGridList)}
                                effect="blur"
                                height="100%"
                                width="100%"
                                alt={handleTitle(property, false, selectedCityFilter, null, true)}/>
                    }

                    {
                        (!isEmpty(property) && property.archived) ?
                            <div className="is-archived w-100 h-100 rounded-8 bg-gray100 d-flex flex-column align-items-center justify-content-center">
                                <Icon width={80}><TransactionIcon/></Icon>
                                <span className="text-primary h3 mt-8">ملک آرشیوی</span>
                            </div>
                            :
                            ''
                    }

                    {
                        (!isEmpty(categories) && categories === 'my_properties' && property.visit_count) ?
                            <VisitCount className={"d-flex justify-content-center align-items-center"}>
                                <Icon width="16" height="16">
                                    <EyeIcon/>
                                </Icon>
                                <span className="mr-4">{property.visit_count}</span>
                            </VisitCount>
                            : ''
                    }
                </Image>
            </PropertyImageCustomTag>


            {
                (!property.archived) ?
                    <React.Fragment>
                        {
                            ((isEmpty(categories) || categories !== 'my_properties') && !isBadeSaba) ?
                                <Bookmark
                                    className={"d-flex justify-content-center align-items-center follow-box-" + property.id + ' ' + (inArray(property.id, bookmarkedProperties) ? 'followed' : '')}
                                    onClick={() => handleClickOnBookmark(property.id, !inArray(property.id, bookmarkedProperties))}>
                                    <Icon width="24" height="24">
                                        <BookmarkIcon/>
                                    </Icon>
                                </Bookmark>
                                : ''
                        }

                        <ContactButton onClick={handleClickOnContactButton}
                                       className="d-flex d-md-none align-items-center justify-content-center rounded-circle bg-white cursor-pointer">
                            <Icon width="18" height="20">
                                <PhoneIcon/>
                            </Icon>
                        </ContactButton>

                        {
                            isEmpty(videoPath) ?
                                <PropertyImageCustomTag
                                    is_link={isEmpty(videoPath)}
                                    getPropertyUrl={getPropertyUrl}
                                    property={property}
                                    isBadeSaba={isBadeSaba}
                                    handleShowProperty={handleShowProperty}
                                    item_count={(imgCount + videoCount)}
                                >
                                    <Medias className="d-flex d-lg-none align-items-center">
                                        <MediaItems img_count={imgCount} video_count={videoCount}/>
                                    </Medias>

                                    <FooterContainer className={(imgCount > 0 ? 'has-media' : '')}>
                                        <Footer className="d-flex justify-content-between align-items-center">
                                            <Time className={((imgCount > 0) ? 'text-white' : '')}>{time_ago(boosted_at, '6_month')}</Time>

                                            <div className="d-none d-lg-flex align-items-center media-box">
                                                <MediaItems img_count={imgCount} video_count={videoCount}/>
                                            </div>
                                        </Footer>
                                    </FooterContainer>
                                </PropertyImageCustomTag>
                                : ''
                        }

                    </React.Fragment>
                    : ''
            }
        </Card>
    );
}

export const PropertyImageCustomTag = ({is_link, getPropertyUrl, property, isBadeSaba, handleShowProperty, item_count, children}) => {

    if (is_link) {
        return (
            <a href={getPropertyUrl(property, isBadeSaba)}
               onClick={(e) => handleShowProperty(e, getPropertyUrl(property, isBadeSaba), item_count)}>
                {children}
            </a>
        )
    } else {
        return (
            <div className="w-100 h-100 ">{children}</div>
        )
    }
}

// *********
// styles
// *********

const Card = styled.div`
  position: relative;
  width: 260px;
  height: 185px;
  object-fit: contain;
  border-radius: 8px;
  background-color: ${props => props.theme.gray100};

  @media (max-width: ${props => props.theme.screenXsMax}) {
    width: 100%;
    height: 54vw;
  }

  .property-card-badge {
    position: absolute;
    top: 16px;
    right: 16px;
    color: ${props => props.theme.black};

    @media (max-width: ${props => props.theme.screenXsMax}) {
      right: auto;
      left: 16px;
    }
  }
`;

export const Image = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.gray250};
  border-radius: 8px;

  img {
    background-color: ${props => props.theme.gray250};
    border-radius: 8px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 50%;
    object-position: 50% 50%;
  }

  .is-archived {
    position: absolute;
    top: 0;
    left: 0;

    @media (max-width: ${props => props.theme.screenSmMax}) {
      .icons {
        width: 86px;
        min-width: 86px;
        max-width: 86px;
      }
    }
  }
`;

export const VideoIframeCard = styled.div`
  position: relative;
  height: 100%;
  border-radius: 8px;

  .ratio {
    display: block;
    width: 100%;
    height: auto;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
`

const VideoIframeTime = styled.div`
  position: absolute;
  bottom: 8px;
  right: 12px;
  border-radius: 0 0 8px 8px;
  text-align: right;
  line-height: 1;
  
  &, & * {
    color: ${props => props.theme.black} !important;
  }
`

export const Bookmark = styled.span`
  position: absolute;
  top: 16px;
  right: 12px;
  z-index: 2;
  cursor: pointer;

  .grid-view-property-image & {
    right: auto;
    left: 12px;
  }

  &.followed {
    svg {
      path, polygon {
        fill: #ef394e;
        //stroke: #ef394e;
      }
    }
  }

  svg {
    path {
      fill: rgba(0, 0, 0, 0.5);
      stroke: rgb(255, 255, 255);
      stroke-width: 1.2;
    }
  }

  &:hover {
    svg {
      path {
          // stroke: ${props => props.theme.dangerText};
      }
    }
  }
`;

export const VisitCount = styled.span`
  position: absolute;
  top: 16px;
  right: 12px;
  z-index: 2;
  line-height: 1;

  svg {
    path {

      stroke-width: 1.2;
    }
  }
`;

const ContactButton = styled.div`
  position: absolute;
  left: 16px;
  bottom: -24px;
  width: 48px;
  height: 48px;
  box-shadow: -1px 2px 2px 0 rgba(34, 34, 34, 0.16);
  z-index: 12;

  .grid-view-property-image & {
    display: none !important;
  }

  i {
    transform: rotateZ(90deg);

    svg {
      path {
        stroke: ${props => props.theme.primary};

        stroke-width: 1.2;
      }
    }
  }
`;

const Medias = styled.div`
  position: absolute;
  top: 12px;
  left: 16px;
  color: #ffffff;

  svg {
    path, g {
      stroke: #ffffff;
      stroke-width: 1.2;
    }
  }
`;

export const Time = styled.time`
  color: ${props => props.theme.black};
  font-size: ${ConvertPixelToRem(12)};
  font-weight: normal;
  line-height: 1.58;
  margin-left: auto;

  .has-video & {
    color: ${props => props.theme.white};
  }
`;


export const FooterContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 70%;
  bottom: 0;
  right: 0;
  left: 0;
  cursor: pointer;
  border-radius: 0 0 8px 8px;

  &.has-media {
    box-shadow: rgba(0, 0, 0, 0.6) 0px -100px 50px -50px inset;

    ${Time} {
      color: ${props => props.theme.white};
    }
  }
`;

export const Footer = styled.div`
  position: absolute;
  right: 16px;
  left: 16px;
  bottom: 10px;
  color: ${props => props.theme.white};

  .media-box {
    svg {
      path, g {
        stroke: #ffffff;
        stroke-width: 1.2;
      }
    }

    .just-video {
      svg {
        path, g {
          stroke: ${props => props.theme.black};
        }
      }
    }
  }

  .has-video & {
    .just-video {
      svg {
        path, g {
          stroke: ${props => props.theme.white} !important;
        }
      }
    }
  }
`;
